import { Component } from 'ng-metadata/core';
import './form-header.component.scss';

/**
 * @ngdoc directive
 * @name mwFormHeader
 * @module mw.components.form
 *
 * @description
 * `<mw-form-header>` provides a means for separating and describing groups of form items.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <!-- Standard Header -->
 *   <mw-form-header>Standard Form Header</mw-form-header>
 *
 * </hljs>
 *
 */

@Component({
    selector: 'mw-form-header',
    template: `
        <md-subheader class="mw-form-header md-no-sticky">
            <span class="mw-form-header__label">
                <ng-transclude></ng-transclude>
            </span>
        </md-subheader>
    `,
    legacy: {
        transclude: true
    }
})
export class FormHeaderComponent {
    constructor() {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/form/form-header/form-header.component.ts